var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 637,
    viewBox: "0 0 700 637",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.89939,
    cy: 6.04587,
    r: 5.89939,
    fill: "#E6E6E6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.89939,
    cy: 44.0642,
    r: 5.89939,
    fill: "#E6E6E6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.973,
    cy: 6.04587,
    r: 5.89939,
    fill: "#E6E6E6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.973,
    cy: 44.0642,
    r: 5.89939,
    fill: "#E6E6E6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.046,
    cy: 6.04587,
    r: 5.89939,
    fill: "#E6E6E6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.046,
    cy: 44.0642,
    r: 5.89939,
    fill: "#E6E6E6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.936,
    cy: 6.04587,
    r: 5.89939,
    fill: "#E6E6E6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.936,
    cy: 44.0642,
    r: 5.89939,
    fill: "#E6E6E6"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 234.009,
    cy: 6.04587,
    r: 5.89939,
    fill: "#E6E6E6"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 234.009,
    cy: 44.0642,
    r: 5.89939,
    fill: "#E6E6E6"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.9179,
    cy: 6.04587,
    r: 5.89939,
    fill: "#E6E6E6"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.9175,
    cy: 44.0642,
    r: 5.89939,
    fill: "#E6E6E6"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.991,
    cy: 6.04587,
    r: 5.89939,
    fill: "#E6E6E6"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.991,
    cy: 44.0642,
    r: 5.89939,
    fill: "#E6E6E6"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.954,
    cy: 6.04587,
    r: 5.89939,
    fill: "#E6E6E6"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.954,
    cy: 44.0642,
    r: 5.89939,
    fill: "#E6E6E6"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 272.027,
    cy: 6.04587,
    r: 5.89939,
    fill: "#E6E6E6"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 272.027,
    cy: 44.0642,
    r: 5.89939,
    fill: "#E6E6E6"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 693.899,
    cy: 630.899,
    r: 5.89939,
    fill: "#E6E6E6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.1689ef7fcf7cf706aaf34709a4f74ff4.svg";
export { ForwardRef as ReactComponent };